// extracted by mini-css-extract-plugin
export default {"message":"ChartSetPreferenceList_message__wkM7a"};